import { commandMap } from "./index";

export const help = {
    name: "help",
    description: "Lists all available commands",
    run: () => {
        const commands = Object.values(commandMap);
        const longest = Math.max(...commands.map(cmd => cmd.name.length));
        return commands
            .map(cmd => "`" + cmd.name.padEnd(longest + 2) + "`- " + cmd.description)
            .join("\n");
    }
};